import { getHexMapping } from "../ultis/helper";
import { Cell, MapData } from "../ultis/types";
const mapOrigin = require("../ultis/map_origin.json");
const colorOrigin = [
  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 12, 12, 12, 12, 12, 12, 12, 12, 6, 4, 12, 12,
  12, 12, 12, 12, 12, 12, 6, 4, 12, 12, 12, 12, 12, 12, 12, 12, 6, 4, 12, 12,
  12, 12, 12, 12, 12, 12, 6, 4, 12, 12, 12, 12, 12, 12, 12, 12, 6, 4, 12, 12,
  12, 12, 12, 12, 12, 12, 6, 4, 12, 12, 12, 12, 12, 12, 12, 12, 6, 4, 12, 12,
  12, 12, 12, 12, 12, 12, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
];

// Area configuration: { name (for debug), x1, y1, x2, y2 }
const AREA_CONFIG = [
  { name: "Tây Bắc 1", x1: 0, y1: 8, x2: 28, y2: 21 },
  { name: "Tây Bắc 2", x1: 6, y1: 22, x2: 28, y2: 37 },

  { name: "Cực Bắc 1", x1: 29, y1: 0, x2: 44, y2: 18 },
  { name: "Cực Bắc 2", x1: 45, y1: 5, x2: 56, y2: 18 },

  { name: "Bắc Center 1", x1: 29, y1: 19, x2: 39, y2: 43 },
  { name: "Bắc Center 2", x1: 40, y1: 19, x2: 50, y2: 43 },
  { name: "Đông Bắc", x1: 51, y1: 19, x2: 73, y2: 43 },

  { name: "Nghệ An", x1: 22, y1: 44, x2: 50, y2: 58 },
  { name: "Hà Tinh", x1: 37, y1: 59, x2: 69, y2: 82 },

  { name: "Miền Trung 1", x1: 51, y1: 83, x2: 85, y2: 100 },
  { name: "Miền Trung 2", x1: 59, y1: 101, x2: 85, y2: 115 },

  { name: "Tây Nguyên 1", x1: 64, y1: 116, x2: 87, y2: 127 },
  { name: "Tây Nguyên 2", x1: 64, y1: 128, x2: 88, y2: 140 },
  { name: "Tây Nguyên 3", x1: 64, y1: 141, x2: 86, y2: 164 },

  { name: "Miền Đông", x1: 53, y1: 140, x2: 63, y2: 175 },

  { name: "Miền Tây 1", x1: 20, y1: 147, x2: 52, y2: 169 },
  { name: "Miền Tây 2", x1: 30, y1: 170, x2: 52, y2: 188 },

  { name: "Hoàng Sa", x1: 108, y1: 78, x2: 129, y2: 97 },
  { name: "Trường Sa", x1: 116, y1: 147, x2: 177, y2: 198 },
];

class DataService {
  // public cellData: Cell[] = [];
  public mapData: MapData[] = [];
  public fullCellData: Cell[] = [];
  public cartItems: Cell[] = [];

  // tọa độ của ô
  findCellByPosition = (x: number, y: number) => {
    for (let i = 0; i < mapOrigin.length; i += 2) {
      if (mapOrigin[i] === x && mapOrigin[i + 1] === y) {
        return {
          x: mapOrigin[i],
          y: mapOrigin[i + 1],
          i: i / 2,
        };
      }
    }
  };

  setMapData = (cellData: any[]): MapData[] => {
    this.fullCellData = [];

    // Initialize area arrays based on config
    const areaArrays: Cell[][] = AREA_CONFIG.map(() => []);

    // Loop through all cells and assign to areas
    for (let i = 0; i < mapOrigin.length; i += 2) {
      const index = i / 2;
      const data = cellData.find((cell: Cell) => cell.i === index);
      let point: Cell = {
        x: mapOrigin[i],
        y: mapOrigin[i + 1],
        c: colorOrigin,
        i: i / 2,
        o: null,
        timestamp: undefined,
        t: undefined,
        l: undefined,
      };

      if (data) {
        point.o = data.o;
        point.timestamp = data.timestamp;
        point.t = data.t;
        point.l = data.l;
        point.c = data.c;
        this.fullCellData.push(point);
      }

      point.c = point.c?.map((item: number) => {
        return Number("0x" + getHexMapping(item));
      });

      // Check which area this cell belongs to
      for (let areaIndex = 0; areaIndex < AREA_CONFIG.length; areaIndex++) {
        const area = AREA_CONFIG[areaIndex];
        if (
          point.x >= area.x1 &&
          point.x <= area.x2 &&
          point.y >= area.y1 &&
          point.y <= area.y2
        ) {
          areaArrays[areaIndex].push({ ...point });
          break; // Cell assigned, move to next cell
        }
      }
    }

    // Build mapData from config and area arrays
    this.mapData = AREA_CONFIG.map((area, index) => ({
      _: `${area.name}_${areaArrays[index].length}`,
      width: area.x2 - area.x1 + 1,
      height: area.y2 - area.y1 + 1,
      x: area.x1,
      y: area.y1,
      data: areaArrays[index],
    }));

    console.log("mapData === ", this.mapData);
    return this.mapData;
  };

  setMapData2 = (cellData: any[]): MapData[] => {
    this.fullCellData = [];

    const mienbac2: Cell[] = [];
    const taynguyen2: Cell[] = [];
    const mientay2: Cell[] = [];
    const hoangsa2: Cell[] = [];
    const truongsa2: Cell[] = [];

    for (let i = 0; i < mapOrigin.length; i += 2) {
      const index = i / 2;
      const data = cellData.find((cell: Cell) => cell.i === index);
      let point: Cell = {
        x: mapOrigin[i],
        y: mapOrigin[i + 1],
        c: colorOrigin,
        i: i / 2,
        o: null,
        timestamp: undefined,
        t: undefined,
        l: undefined,
      };

      if (data) {
        point.o = data.o;
        point.timestamp = data.timestamp;
        point.t = data.t;
        point.l = data.l;
        point.c = data.c;
        this.fullCellData.push(point);
      }

      point.c = point.c?.map((item: number) => {
        return Number("0x" + getHexMapping(item));
      });

      if (point.x >= 0 && point.x <= 73 && point.y >= 0 && point.y <= 90) {
        mienbac2.push({
          ...point,
        });
      } else if (
        point.x >= 53 &&
        point.x <= 90 &&
        point.y >= 91 &&
        point.y <= 177
      ) {
        taynguyen2.push({
          ...point,
        });
      } else if (
        point.x >= 20 &&
        point.x <= 53 &&
        point.y >= 147 &&
        point.y <= 188
      ) {
        mientay2.push({
          ...point,
        });
      } else if (
        point.x >= 108 &&
        point.x <= 129 &&
        point.y >= 78 &&
        point.y <= 97
      ) {
        hoangsa2.push({
          ...point,
        });
      } else if (
        point.x >= 116 &&
        point.x <= 180 &&
        point.y >= 147 &&
        point.y <= 200
      ) {
        truongsa2.push({
          ...point,
        });
      }
    }

    this.mapData = [
      {
        width: 73,
        height: 91,
        x: 0,
        y: 0,
        data: mienbac2,
      },
      {
        width: 37,
        height: 86,
        x: 53,
        y: 91,
        data: taynguyen2,
      },
      {
        width: 33,
        height: 41,
        x: 20,
        y: 147,
        data: mientay2,
      },
      {
        width: 19,
        height: 19,
        x: 108,
        y: 78,
        data: hoangsa2,
      },
      {
        width: 64,
        height: 53,
        x: 116,
        y: 147,
        data: truongsa2,
      },
    ];

    return this.mapData;
  };

  getDetail = (x: number, y: number): Cell | null => {
    const index = this.findCellByPosition(x, y)?.i;
    if (!index && index !== 0) {
      return null;
    }

    const existCell = this.fullCellData.find((cell: Cell) => cell.i === index);
    console.log("existCell", existCell);

    if (existCell) {
      return existCell;
    }
    return {
      i: index,
      x: x,
      y: y,
      o: null,
      timestamp: undefined,
    };
  };

  /**
   * Get 8 neighbor cells around a given cell
   * Returns array in order: [top-left, top, top-right, left, right, bottom-left, bottom, bottom-right]
   * If a neighbor doesn't exist (at map boundary), returns null for that position
   */
  getNeighborCells = (centerCell: Cell): (Cell | null)[] => {
    const neighbors: (Cell | null)[] = [];
    const { x, y } = centerCell;

    // Define neighbor positions relative to center
    const neighborPositions = [
      { x: x - 1, y: y - 1 }, // top-left
      { x: x, y: y - 1 }, // top
      { x: x + 1, y: y - 1 }, // top-right
      { x: x - 1, y: y }, // left
      { x: x + 1, y: y }, // right
      { x: x - 1, y: y + 1 }, // bottom-left
      { x: x, y: y + 1 }, // bottom
      { x: x + 1, y: y + 1 }, // bottom-right
    ];

    for (const pos of neighborPositions) {
      const neighborIndex = this.findCellByPosition(pos.x, pos.y)?.i;

      if (neighborIndex !== undefined && neighborIndex !== null) {
        // Try to find existing cell data
        const existCell = this.fullCellData.find(
          (cell: Cell) => cell.i === neighborIndex
        );

        if (existCell) {
          neighbors.push(existCell);
        } else {
          // Cell exists in map but has no data yet - convert colorOrigin to hex format
          const convertedColors = colorOrigin.map((item: number) => {
            return Number("0x" + getHexMapping(item));
          });
          neighbors.push({
            i: neighborIndex,
            x: pos.x,
            y: pos.y,
            c: convertedColors,
            o: null,
            timestamp: undefined,
            t: undefined,
            l: undefined,
          });
        }
      } else {
        // Neighbor doesn't exist (at map boundary)
        neighbors.push(null);
      }
    }

    return neighbors;
  };
}

const dataService = new DataService();
dataService.setMapData([]);

export default dataService;
